import { deviceWidth } from "./device.js";

export function scrollAction() {
  let targetClass = ".scrollAction";

  let target = $(targetClass);

  if (target.length != 0) {
    $(window).on("load", function () {
      target.each(function () {
        $(this).addClass("__sa_init");
      });
    });
  }

  $(window).on("scroll", function () {
    let scroll_position = $(window).scrollTop();
    let window_height = $(window).height();

    stickyHeader(scroll_position, window_height);

    // console.log(scroll_position, window_height);

    target.each(function () {
      let elm_offset = $(this).offset().top;

      if (scroll_position > elm_offset - window_height + window_height / 3) {
        // console.log(scroll_position, elm_offset);
        $(this).removeClass("__sa_init");
        $(this).addClass("__sa_show");
      }
    });
  });

  // stickey_header

  function stickyHeader(scroll, wHeight) {
    let sticky_header = $("#sticky-header");
    if (scroll > 90) {
      sticky_header.removeClass("isInit");
    } else {
      sticky_header.addClass("isInit");
    }
    if (scroll > wHeight * 0.3) {
      sticky_header.addClass("isShow");
      // sticky_header.css("top",scroll)
    } else {
      sticky_header.removeClass("isShow");
    }
  }

  function justifySubNav() {
    let dev_w = deviceWidth().width;
    let mainnav_init_sizse = $(".header__nav__list").width();
    
    let margin_gap =
      (parseInt($(".header__nav-wrapper").width(), 10) -
        parseInt($(".header__nav").width(), 10)) *
      0.5;
    let mainnav_item = $(".header__nav__listitem");
    let mainnav_size = {
      width: 0,
      margin: 0,
    };

    // console.log(margin_gap);
    for (let i = 0; i < mainnav_item.length; i++) {
      const elm = mainnav_item[i];
      // console.log($(elm).width());
      mainnav_size.width = mainnav_size.width + $(elm).width();
      mainnav_size.margin =
        mainnav_size.margin + parseInt($(elm).css("margin-left"), 10);
    }
    // console.log(mainnav_size);
    // console.log($(".header__nav__list").width());
    // console.log(dev_w)
    let gap = 16;
    if(dev_w <= 991){
      gap = 0;
    }
    
    let addtional_style = {
      // width: mainnav_size.width + mainnav_size.margin + "px",
      width: mainnav_init_sizse - gap + "px",
      "margin-right": "calc(5vw + " + margin_gap + "px)",
    };

    $(".sublist__wrapper").css(addtional_style);
  }


  $(window).on("load resize",function(){
    
    let dev_w = deviceWidth().width

  if (768 < dev_w) {
    $(window).on("scroll load resize", function () {
      justifySubNav(dev_w);
      
    });

    // sub navigation diabled
    $(".header__nav__listitem").on("mouseover", function () {
      $(".sublist__company").removeClass("isShow");
      $(".sublist__recruit").removeClass("isShow");
      $(".header__nav__listitem").removeClass("isActive");
      $("#sticky-header").removeClass("hasActiveSubNav");
    });

    if (dev_w > 768){
      // sub navication enabled
      $(".hasSublist__recruit").on("mouseover", function () {
        justifySubNav();
        let sublist_block = $(".sublist__recruit");
        $(this).addClass("isActive");
        sublist_block.addClass("isShow");
        $("#sticky-header").addClass("hasActiveSubNav");
        let navblock_size = $(this).parent().outerWidth();
        // console.log("navblock_size: ",navblock_size)
        // justify position
        // sublist_block
        //   .find(".sublist__wrapper")
        //   .css({
        //     width: navblock_size,
        //     "margin-left": "auto",
        //     "margin-right": "5vw",
        //   });
        // console.log("fire :", dev_w);
      });

      // sub navication enabled
      $(".hasSublist__company").on("mouseover", function () {
        justifySubNav();
        let sublist_block = $(".sublist__company");
        $(this).addClass("isActive");
        sublist_block.addClass("isShow");
        $("#sticky-header").addClass("hasActiveSubNav");
        let navblock_size = $(this).parent().outerWidth();

        // console.log("navblock_size: ",navblock_size)
        // justify position
        // sublist_block
        //   .find(".sublist__wrapper")
        //   .css({
        //     width: navblock_size,
        //     "margin-left": "auto",
        //     "margin-right": "5vw",
        //   });
        // console.log("fire :", dev_w);
      });
    }

    $(".sublist__company").on("mouseover", function () {
      $(this).addClass("isShow");

      $(this).on("mouseleave", function () {
        $(this).removeClass("isShow");
        $(".header__nav__listitem").removeClass("isActive");
        $("#sticky-header").removeClass("hasActiveSubNav");
      });
    });

    $(".sublist__recruit").on("mouseover", function () {
      $(this).addClass("isShow");

      $(this).on("mouseleave", function () {
        $(this).removeClass("isShow");
        $(".header__nav__listitem").removeClass("isActive");
        $("#sticky-header").removeClass("hasActiveSubNav");
      });
    });
  }
  })
}
